import React from "react";
import styled from "styled-components";
import { Item, Section } from "react-stately";
import { Box, Typography } from "@bca/ui-library";

import PrintMenuButton from "./PrintMenuButton";
import { PrintSections } from "./PrintSection.type";
import PrintMenuSectionIcon from "./PrintMenuSectionIcon";
import PrintLink from "./PrintLink";

const DividerDashed = styled.hr`
  border: 0;
  width: 100%;
  border-top: 1px dashed #979797;
  opacity: 0.3;
  margin-top: 17px;
  margin-bottom: 0px;
`;

const SectionLink: React.FunctionComponent<{
  title: string;
  name: string;
  url: string;
  isToUseAuthZero?: boolean;
  accessToken?: string;
}> = ({ title, name, url, isToUseAuthZero = false, accessToken }) => {
  const sanitizeName = name.toLowerCase();

  return (
    <>
      {title.includes("vehicle details") && (
        <PrintLink
          name={name}
          url={url}
          {...(sanitizeName.includes("with") && {
            dataEl: "vehicle-details-with",
          })}
          {...(sanitizeName.includes("without") && {
            dataEl: "vehicle-details-without",
          })}
          isToUseAuthZero={isToUseAuthZero}
          accessToken={accessToken}
        />
      )}
      {title.includes("sale section") && (
        <PrintLink
          name={name}
          url={url}
          {...(sanitizeName.includes("with") && {
            dataEl: "sale-section-with",
          })}
          {...(sanitizeName.includes("without") && {
            dataEl: "sale-section-without",
          })}
          isToUseAuthZero={isToUseAuthZero}
          accessToken={accessToken}
        />
      )}
      {title.includes("print all") && (
        <PrintLink
          name={name}
          url={url}
          {...(title.includes("print all bid") &&
            sanitizeName.includes("with") && {
              dataEl: "all-bid-now-with",
            })}
          {...(title.includes("print all bid") &&
            sanitizeName.includes("without") && {
              dataEl: "all-bid-now-without",
            })}
          {...(title.includes("print all buy") &&
            sanitizeName.includes("with") && {
              dataEl: "all-buy-now-with",
            })}
          {...(title.includes("print all buy") &&
            sanitizeName.includes("without") && {
              dataEl: "all-buy-now-without",
            })}
          isToUseAuthZero={isToUseAuthZero}
          accessToken={accessToken}
        />
      )}
      {title.includes("print full") && (
        <PrintLink
          name={name}
          url={url}
          {...(sanitizeName.includes("with") && {
            dataEl: "full-day-with",
          })}
          {...(sanitizeName.includes("without") && {
            dataEl: "full-day-without",
          })}
          isToUseAuthZero={isToUseAuthZero}
          accessToken={accessToken}
        />
      )}
    </>
  );
};

const PrintMenuWithList: React.FunctionComponent<{
  printSections: PrintSections[];
  isToUseAuthZero?: boolean;
  accessToken?: string;
}> = ({ printSections, isToUseAuthZero = false, accessToken }) => {
  const openInNewTab = (link) => {
    if (!link.includes("https")) return;
    window.open(link, "_blank");
  };

  return (
    <PrintMenuButton
      onAction={(link) => openInNewTab(link)}
      type="menu"
      role="menu"
      aria-label="Print menu options"
    >
      {printSections.map((section, index) => (
        <Section key={`section-${index}`}>
          <Item key={section.title} textValue={section.title}>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              flex={1}
              minWidth={0}
              height="auto"
              marginLeft="36px"
            >
              <PrintMenuSectionIcon
                title={section?.title.toLowerCase()}
              ></PrintMenuSectionIcon>
              <Typography
                variant="body"
                color="grey-blue"
                marginBottom="9px"
                marginLeft="12px"
              >
                {section.title}
              </Typography>
            </Box>
          </Item>
          <Item
            key={`section-withGuidePricing-${index}`}
            textValue={section.withGuidePricing.name}
          >
            {section.isGuidePricingDisabled && (
              <Typography
                marginY="0"
                css={`
                  font-size: 16px;
                  font-weight: 500;
                  margin-left: 36px;
                  opacity: 0.3;
                `}
                color="footer-blue"
              >
                {section.withGuidePricing.name}
              </Typography>
            )}
            {!section.isGuidePricingDisabled && (
              <SectionLink
                title={section.title.toLowerCase()}
                name={section.withGuidePricing.name}
                url={section.withGuidePricing.url}
                isToUseAuthZero={isToUseAuthZero}
                accessToken={accessToken}
              />
            )}
          </Item>
          <Item
            key={`section-withoutGuidePricing-${index}`}
            textValue={section.withoutGuidePricing.name}
          >
            <SectionLink
              title={section.title.toLowerCase()}
              name={section.withoutGuidePricing.name}
              url={section.withoutGuidePricing.url}
              isToUseAuthZero={isToUseAuthZero}
              accessToken={accessToken}
            />
            {index !== printSections.length - 1 && <DividerDashed />}
          </Item>
        </Section>
      ))}
    </PrintMenuButton>
  );
};

export default PrintMenuWithList;
